import { render, staticRenderFns } from "./InternationalShippingListDialog.vue?vue&type=template&id=c34d1bc2"
import script from "./InternationalShippingListDialog.vue?vue&type=script&lang=js"
export * from "./InternationalShippingListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports